import Vue from 'vue'
import SecurePaymentModel from '@/lib/models/secure-payment'
import log from '@/plugins/log'
import LegacyApi from '@/lib/api/legacy'
import securePaymentsFillModel from '@/lib/helpers/secure-payments-fill-model'

const initialState = () => {
  return {
    existingApi: new LegacyApi(),
    profileApi: new LegacyApi(),
    createApi: new LegacyApi(new SecurePaymentModel()),
    updateApi: new LegacyApi(),
    getBanksApi: new LegacyApi()
  }
}

const getters = {
  isListing: state => {
    return state.createApi.model.listing && state.createApi.model.listing.listingRef !== undefined
  },

  isBuyer: state => {
    return state.createApi.model.initiator === 'buyer'
  },

  isVerified: () => {
    // return get(state.profileApi, 'data.flags.verified')
    return true
  },

  existingBank: state => {
    return state.getBanksApi.data?.[0] || null
  },

  // supportedBanks: state => {
  //   let providers = get(state.supportedBanksApi, 'data.results')

  //   return providers || []
  // },

  list: state => {
    return [
      ...(state.existingApi.data.received || []).map(t => securePaymentsFillModel(t)),
      ...(state.existingApi.data.sent || []).map(t => securePaymentsFillModel(t))
    ]
  },

  liveList: (state, getters) => {
    return getters.list.filter(t => !t.isCancelled)
  },

  needsActionCount: (state, getters) => {
    return getters.list.filter(t => {
      const transaction = securePaymentsFillModel(t)

      return transaction.isActionRequired
    }).length
  }
}

const actions = {
  async getExisting({ state, rootGetters }) {
    let appIs = rootGetters['app/appIs']

    if (!appIs.auth) {
      return false
    }

    try {
      await state.existingApi.get(
        'invoices.get',
        {
          userRef: rootGetters['app/getApp'].user.userRef,
          status: ['L', 'C', 'W', 'D']
        },
        {
          throttleMs: 5000
        }
      )
    } catch (error) {
      log.debug('Error loading secure payment transactions', error)
    }
  },

  async getBankDetails({ state, rootGetters }) {
    await state.getBanksApi.get('banks.get', {
      companyRef: rootGetters['app/getApp'].company.companyRef
    })
  },

  // async getProfile({ state, rootGetters }) {
  //   let appIs = rootGetters['app/appIs']

  //   if (!appIs.auth) {
  //     return false
  //   }

  //   await state.profileApi.get('/payments/v2/transaction/customer', undefined, { throttleMs: 2000 })
  // },

  // async getTrueLayerSupportedBanks({ state }) {
  //   await state.supportedBanksApi.get('/payments/v2/transaction/tl/providers')
  // },

  async changeStatus({ state }, { transactionId, statusId }) {
    await state.updateApi.put(`/payments/v2/transaction/sp/${transactionId}/status/${statusId}`)
  },

  startSecurePaymentFromMessages(context, { listing, listingIs, otherParty, quantity, total }) {
    if (otherParty) {
      // SP requires "email" as a root key so we need to manually map legacy format it before passing in
      let email = otherParty.emailAddresses ? otherParty.emailAddresses[0] : otherParty.emailAddress

      otherParty = { ...otherParty, email }
    }

    Vue.prototype.$modal.open('ModalSecurePayment', {
      initiator: listingIs.owner ? 'seller' : 'buyer',
      listing,
      otherParty,
      quantity,
      total
    })
  }
}

const mutations = {
  resetCreate(state) {
    Object.assign(state.createApi, initialState().createApi)
  },

  reset(state) {
    Object.assign(state, initialState())
  }
}

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations,
  getters
}
